module.exports = __webpack_public_path__ + "static/media/tv.edb58b96.svg";